"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'limits.writingStyles.disabled': 'Writing styles feature is not available in your current plan.',
};
